import * as React from 'react';
import { ProductCatalogList } from '../components/Menu';
import { UserListType } from '../pages/home/users/constants';

export const menuConfigItems = {
  profile: {
    root: true,
    title: 'SUBMENU.PROFILE',
    translate: 'SUBMENU.PROFILE',
    page: 'settings/profile',
    activePages: ['settings/profile'],
  },

  logout: {
    root: true,
    title: 'MENU.LOGOUT',
    translate: 'MENU.LOGOUT',
    page: 'logout',
    // icon: 'flaticon-logout',
  },

  products: {
    title: 'MENU.PRODUCTS',
    translate: 'MENU.PRODUCTS',
    bullet: 'dot',
    root: true,
    activePages: ['products', 'categories', 'viewproduct'],
    inActivePages: ['products/types'],
    page: 'products/catalog',
    submenu: [
      {
        title: 'PRODUCT.ALL.PRODUCTS',
        translate: 'PRODUCT.ALL.PRODUCTS',
        page: 'products/catalog',
        activePages: ['products/catalog'],
        dynamic: () => <ProductCatalogList />,
      },
      {
        title: 'IMPORT.OFFERS',
        translate: 'IMPORT.OFFERS',
        page: 'products/offer/import',
        activePages: ['products/offer/import'],
      },
      // {
      //   title: 'IMPORT.NEW.PRODUCTS',
      //   translate: 'IMPORT.NEW.PRODUCTS',
      //   page: 'products/new/import',
      //   activePages: ['products/new/import'],
      // },
      // {
      //   title: 'IMPORT.PRODUCT.DATA',
      //   translate: 'IMPORT.PRODUCT.DATA',
      //   page: 'products/import_product_data',
      //   activePages: ['products/import_product_data'],
      // },
      {
        title: 'PRICES.MODERATION',
        translate: 'PRICES.MODERATION',
        page: 'products/offers/moderation',
        activePages: ['products/offers/moderation'],
      },
      {
        title: 'MENU.CATALOG.CATEGORIES.LIST',
        page: 'categories/list',
        translate: 'MENU.CATALOG.CATEGORIES.LIST',
        activePages: ['categories/edit', 'categories/new'],
      },
      {
        title: 'MENU.CATALOG.CATEGORIES.TREE',
        page: 'categories/tree',
        translate: 'MENU.CATALOG.CATEGORIES.TREE',
      },
    ],
  },

  vendorProducts: {
    title: 'MENU.PRODUCTS',
    translate: 'MENU.PRODUCTS',
    bullet: 'dot',
    root: true,
    activePages: ['products', 'categories', 'viewproduct'],
    page: 'products/catalog',
    submenu: [
      {
        title: 'PRODUCT.ALL.PRODUCTS',
        translate: 'PRODUCT.ALL.PRODUCTS',
        page: 'products/catalog',
        activePages: ['products/catalog'],
      },
      {
        title: 'MY.PRODUCTS',
        translate: 'MY.PRODUCTS',
        page: 'products/catalog/my_company',
        activePages: ['products/catalog/my_company', 'products/catalog/company'],
      },
      {
        title: 'IMPORT.OFFERS',
        translate: 'IMPORT.OFFERS',
        page: 'products/offer/import',
        activePages: ['products/offer/import'],
      },
    ],
  },

  orders: {
    root: true,
    title: 'MENU.ORDERS',
    translate: 'MENU.ORDERS',
    bullet: 'dot',
    activePages: ['orders/'],
    page: 'orders/list/full',
    submenu: [
      {
        translate: 'SUBMENU.ALLORDERS',
        title: 'SUBMENU.ALLORDERS',
        page: 'orders/list/full',
      },
      {
        translate: 'SUBMENU.ABANDONEDCHECKOUTS',
        title: 'SUBMENU.ABANDONEDCHECKOUTS',
        page: 'orders/list/abandoned',
      },
    ],
  },

  buyersOrders: {
    root: true,
    title: 'MENU.MY_ORDERS',
    translate: 'MENU.MY_ORDERS',
    bullet: 'dot',
    page: 'orders/list/full',
    activePages: ['orders'],
  },

  vendorsAdmin: {
    root: true,
    title: 'MENU.VENDORS',
    translate: 'MENU.VENDORS',
    bullet: 'dot',
    activePages: ['users/vendors', 'users/staff', `companies/list/${UserListType.VENDOR}`],
    page: 'users/vendors',
    submenu: [
      {
        translate: 'SUBMENU.CUSTOMERS.LIST',
        title: 'SUBMENU.CUSTOMERS.LIST',
        page: 'users/vendors',
      },
      {
        translate: 'SUBMENU.MANAGERS',
        title: 'SUBMENU.MANAGERS',
        page: 'users/staff',
      },
      {
        translate: 'SUBMENU.COMPANIES',
        title: 'SUBMENU.COMPANIES',
        page: `companies/list/${UserListType.VENDOR}`,
      },
    ],
  },
  buyersAdmin: {
    root: true,
    title: 'MENU.BUYERS',
    translate: 'MENU.BUYERS',
    bullet: 'dot',
    activePages: ['users/buyers', 'users/buyer-staff', `companies/list/${UserListType.BUYER}`],
    page: 'users/buyers',
    submenu: [
      {
        translate: 'SUBMENU.CUSTOMERS.LIST',
        title: 'SUBMENU.CUSTOMERS.LIST',
        page: 'users/buyers',
      },

      {
        translate: 'SUBMENU.MANAGERS',
        title: 'SUBMENU.MANAGERS',
        page: 'users/buyer-staff',
      },

      {
        translate: 'SUBMENU.COMPANIES',
        title: 'SUBMENU.COMPANIES',
        page: `companies/list/${UserListType.BUYER}`,
      },
    ],
  },

  usersManager: {
    root: true,
    title: 'MENU.USERS',
    translate: 'MENU.USERS',
    bullet: 'dot',
    activePages: ['users'],
    page: 'users/vendors',
    submenu: [
      {
        translate: 'SUBMENU.VENDORS',
        title: 'SUBMENU.VENDORS',
        page: 'users/vendors',
      },
      {
        translate: 'SUBMENU.VENDORS.STAFF',
        title: 'SUBMENU.VENDORS.STAFF',
        page: 'users/staff',
      },
      {
        translate: 'SUBMENU.BUYERS.STAFF',
        title: 'SUBMENU.BUYERS.STAFF',
        page: 'users/buyer-staff',
      },
      {
        translate: 'SUBMENU.COMPANIES',
        title: 'SUBMENU.COMPANIES',
        page: 'companies/list',
      },
    ],
  },

  settings: {
    root: true,
    title: 'MENU.SETTINGS',
    bullet: 'dot',
    translate: 'MENU.SETTINGS',
    activePages: ['products/types'],
    page: 'products/types/list',
    submenu: [
      {
        title: 'MENU.PRODUCTS.TYPES',
        translate: 'MENU.PRODUCTS.TYPES',
        page: 'products/types/list',
        activePages: ['products/types/create'],
      },
      {
        title: 'SITE.REQUISITES',
        translate: 'SITE.REQUISITES',
        page: 'settings/requisites',
        activePages: ['settings/requisites'],
      },
    ],
  },

  legal: {
    root: true,
    title: 'SUBMENU.LEGAL',
    translate: 'SUBMENU.LEGAL',
    bullet: 'dot',
    activePages: ['documents'],
    page: 'documents/legacy',
    submenu: [
      {
        title: 'SUBMENU.LEGAL_TERMS',
        translate: 'SUBMENU.LEGAL_TERMS',
        page: 'documents/legacy',
      },
      {
        title: 'SUBMENU.LEGAL_PRIVACY',
        translate: 'SUBMENU.LEGAL_PRIVACY',
        page: 'documents/privacy',
      },
      {
        title: 'SUBMENU.MARKETPLACE.COMMISSION',
        translate: 'SUBMENU.MARKETPLACE.COMMISSION',
        page: 'documents/commission',
      },
      {
        title: 'PUBLIC.OFFER',
        translate: 'PUBLIC.OFFER',
        page: 'documents/public_offer',
      },
      {
        title: 'SUBMENU.IMPORT.INSTRUCTION',
        translate: 'SUBMENU.IMPORT.INSTRUCTION',
        page: 'documents/import_instruction',
      },
    ],
  },

  catalogForUser: {
    root: true,
    title: 'MENU.CATALOG.PRODUCTS',
    translate: 'MENU.CATALOG.PRODUCTS',
    bullet: 'dot',
    // icon: 'flaticon-book',
    page: 'products/catalog',
    dynamic: () => <ProductCatalogList />,
    activePages: ['products', 'viewproduct'],
    submenu: [
      {
        title: 'MENU.CATALOG.PRODUCTS',
        translate: 'MENU.CATALOG.PRODUCTS',
        page: 'products/catalog',
        activePages: ['products/catalog'],
        dynamic: () => <ProductCatalogList />,
      },
      {
        title: 'IMPORT.OFFERS',
        translate: 'IMPORT.OFFERS',
        page: 'products/offer/import',
        activePages: ['products/offer/import'],
      },
      {
        title: 'IMPORT.NEW.PRODUCTS',
        translate: 'IMPORT.NEW.PRODUCTS',
        page: 'products/new/import',
        activePages: ['products/new/import'],
      },
      {
        title: 'IMPORT.PRODUCT.DATA',
        translate: 'IMPORT.PRODUCT.DATA',
        page: 'products/import_product_data',
        activePages: ['products/import_product_data'],
      },
      {
        title: 'PRICES.MODERATION',
        translate: 'PRICES.MODERATION',
        page: 'products/offers/moderation',
        activePages: ['products/offers/moderation'],
      },
    ],
  },

  ordersVendor: {
    root: true,
    title: 'MENU.ORDERS',
    translate: 'MENU.ORDERS',
    bullet: 'dot',
    activePages: ['orders/'],
    page: 'orders/list/full',
  },
};
